export const openServiceLevelFeedbackSuccessModal = () => {
  $core.$modals.openModal({
    modalId: 'yhc-service-level-feedback-success',
    modalProps: {
      title: '投稿が完了しました',
      size: 'sm',
      centered: true,
      okOnly: true,
      okTitle: '閉じる',
      hideHeaderClose: true,
      bodyClass: 'p-0',
    },
    component: {
      name: 'YhcServiceLevelFeedbackSuccessModal',
      template: '<div></div>',
    },
  })
}
